import { paginationResponseTransformer } from '@/utils/pagination/pagination';
import { getRequest } from '../request/request.service';
import { Maintenance, Maintenances, MaintenancesParams } from './maintenances-service.types';

const MAINTENANCES_URL = 'maintenances';
export function getMaintenances(params: MaintenancesParams) {
  return getRequest<Maintenances>(
    `/${MAINTENANCES_URL}`,
    { params },
    paginationResponseTransformer
  );
}

export function getMaintenance(id: number) {
  return getRequest<Maintenance>(`/${MAINTENANCES_URL}/${id}`);
}
